const state = () => ({
  relatorioCarregado: null,
  relatorioSalvo: null,
  relatorioNotificacao: null,
  loadingPersonalizado: false,
  aguardandoFiltros: false,
});

const mutations = {
  SALVAR_RELATORIO(state, payload) {
    state.relatorioCarregado = payload.relatorio;
  },
  SALVAR_RELATORIO_NOTIFICACAO(state, payload) {
    state.relatorioNotificacao = payload.relatorio;
  },
  ALTERAR_RELATORIO_SALVO(state, payload) {
    state.relatorioSalvo = payload.estado;
  },
  ATIVAR_LOADING_PERSONALIZADO(state) {
    state.loadingPersonalizado = true;
  },
  DESATIVAR_LOADING_PERSONALIZADO(state) {
    state.loadingPersonalizado = false;
  },
  SET_AGUARDANDO_FILTROS(state, payload) {
    state.aguardandoFiltros = payload;
  },
};

const actions = {
  //Relatórios salvos

  listarRelatoriosSalvos: async (
    context,
    { tipoRelatorio, nome, criadoEm, id, page, perPage }
  ) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(`bi/relatorio`, {
      params: {
        tipoRelatorio,
        nome,
        criadoEm,
        id,
        page,
        perPage,
      },
    });

    return response;
  },

  salvarRelatorio: async (
    context,
    { nome, url, tipoRelatorio, template, filtros }
  ) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.post(`bi/relatorio`, {
      nome,
      url,
      tipoRelatorio,
      template,
      filtros,
    });

    return response;
  },

  editarRelatorio: async (context, { id, url, template, filtros }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`bi/relatorio/${id}`, {
      url,
      template,
      filtros,
    });

    return response;
  },

  exluirRelatorio: async (context, { id }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`bi/relatorio/${id}`);

    return response;
  },

  getCarregado: async (context, { url }) => {
    const api = context.rootState.autenticacao.apiLegado;
    console.log(url);
    const response = await api.get(`${url}`, {});

    return response;
  },

  getConsumo: async (
    context,
    {
      data_finalizacao_inicial,
      data_finalizacao_final,
      unidade_ids,
      regiao,
      background,
      categoria_produto_codigo,
      grupo_produto_nome,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`bi/consumo`, {
      params: {
        data_finalizacao_inicial,
        data_finalizacao_final,
        unidade_ids,
        regiao,
        background,
        categoria_produto_codigo,
        grupo_produto_nome,
      },
    });

    return response;
  },

  getTrocasProdutosRequisicao: async (context, { filtros }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`requisicao/relatorio-troca-produto`, {
      filtros,
    });

    return response;
  },

  getVouchersCanceladosRejeitados: async (context, { filtros }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`vouchers/report/cancelados`, {
      params: { ...filtros, per_page: 99999 },
    });

    return response;
  },

  getRelatorioSalvo: async (context, { tipo }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`bi/customizacao`, {
      params: {
        tipo,
      },
    });

    return response;
  },
  getRelatorioSalvoEspecifico: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`bi/customizacao`, {
      params: {
        id,
      },
    });

    return response;
  },
  excluirRelatorioSalvo: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`bi/customizacao`, {
      params: {
        id,
      },
    });

    return response;
  },

  // Permissão de Trabalho

  getPermissaoDeTrabalho: async (
    context,
    { unidadeId, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`pdt/pt/relatorio`, {
      params: {
        unidadeId,
        dataInicial,
        dataFinal,
      },
    });

    return response;
  },

  // Relatório Geral de PTs
  getRelatorioGeralPT: async (
    context,
    {
      unidadeId,
      modeloId,
      ptId,
      emissor,
      status,
      local,
      dataInicial,
      dataFinal,
      participante,
      atividade,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`pdt/pt/relatorioGeral`, {
      params: {
        unidadeId,
        modeloId,
        ptId,
        emissor,
        status,
        local,
        dataInicial,
        dataFinal,
        participante,
        atividade,
      },
    });

    return response;
  },

  // Relatório Atividades PT
  getRelatorioAtividadesPT: async (
    context,
    {
      unidadeId,
      modeloId,
      ptId,
      emissor,
      status,
      local,
      dataInicial,
      dataFinal,
      participante,
      atividade,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`pdt/pt/relatorioAtividades`, {
      params: {
        unidadeId,
        modeloId,
        ptId,
        emissor,
        status,
        local,
        dataInicial,
        dataFinal,
        participante,
        atividade,
      },
    });

    return response;
  },

  // Relatório Participantes PT
  getRelatorioParticipantesPT: async (
    context,
    {
      unidadeId,
      modeloId,
      ptId,
      emissor,
      status,
      local,
      dataInicial,
      dataFinal,
      participante,
      atividade,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`pdt/pt/relatorioParticipantes`, {
      params: {
        unidadeId,
        modeloId,
        ptId,
        emissor,
        status,
        local,
        dataInicial,
        dataFinal,
        participante,
        atividade,
      },
    });

    return response;
  },

  //Master Data

  getMasterData: async (
    context,
    { vendor_id, status, desligado, background }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`bi/master-data`, {
      params: {
        vendor_id,
        status,
        desligado,
        background,
      },
    });

    return response;
  },

  // Custos Consolidado
  getCustosConsolidado: async (context, payload = {}) => {
    const { background } = payload;
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`bi/relatorio-custos`, {
      params: {
        background,
      },
    });

    return response;
  },
  // Custos
  getCustos: async (
    context,
    { vendor_id, data_inicial, data_final, background }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/report/custos/export`, {
      params: {
        vendor_id,
        data_inicial,
        data_final,
        background,
      },
    });

    return response;
  },

  // Necessidade Compra
  getNecessidadeCompra: async (context, { data_inicial, data_final }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`necessidade-compra/consolidada/export`, {
      params: {
        data_inicial,
        data_final,
      },
    });

    return response;
  },

  //Status Troca

  getStatusTroca: async (
    context,
    { vendor_id, regra_critica, status, turno_ids }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-groups/report`, {
      params: {
        download: "flexmonster",
        vendor_id,
        regra_critica,
        status,
        turno_ids,
      },
    });

    return response;
  },

  //Produtos em Aberto

  getProdutosEmAberto: async (context, { vendor_id, background }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/report/em-aberto/export`, {
      params: {
        vendor_id,
        background,
      },
    });

    return response;
  },

  //Produtos em Aberto

  getProdutosEmAbertoUserLogado: async (context, { vendor_id, background }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `vouchers/report/em-aberto/export/logged-user`,
      {
        params: {
          vendor_id,
          background,
        },
      }
    );

    return response;
  },

  //Estoque

  getEstoque: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendors/reports/stock/export`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  //Consumo por Estoque Lote

  getEstoqueConsumoLote: async (
    context,
    { initial_date, final_date, vendor_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/report/consumo-por-lote/export`, {
      params: {
        initial_date,
        final_date,
        vendor_id,
      },
    });

    return response;
  },

  //Estoque Lote

  getEstoqueLote: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendors/reports/estoque-por-lote/export`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  //Ferramentas

  getFerramentas: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `ferramentas/listar-ferramentas/simplificada/export`,
      {
        params: {
          vendor_id,
        },
      }
    );

    return response;
  },

  //Liberação Fora do Prazo

  getLiberacaoForaPrazo: async (
    context,
    { vendor_id, initialDate, finalDate }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`log-temporary-withdrawal/export`, {
      params: {
        vendor_id,
        initialDate,
        finalDate,
      },
    });

    return response;
  },

  //Transferência de Ferramentas

  getTransferenciaFerramentas: async (
    context,
    { origem_id, destino_id, data_inicial, data_final }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`transferencia-ferramenta/export`, {
      params: {
        origem_id,
        destino_id,
        data_inicial,
        data_final,
        download: "csv",
      },
    });

    return response;
  },

  //Estoque Localização

  getEstoqueLocalizacao: async (context, { vendor_id, background }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`estoque-por-localizacao/export`, {
      params: {
        vendor_id,
        background,
      },
    });

    return response;
  },

  //Segurança Emocional

  getSegurancaEmocional: async (
    context,
    { unidadeId, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`cse/resposta/relatorio`, {
      params: {
        unidadeId,
        dataInicial,
        dataFinal,
      },
    });

    return response;
  },

  //Emprestimo ferramenta

  getEmprestimoFerramenta: async (
    context,
    { unidadeId, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/ferramentas/listar-ferramentas/movimentacao/export`,
      {
        params: {
          unidadeId,
          dataInicial,
          dataFinal,
        },
      }
    );

    return response;
  },

  //Movimentação Status

  getMovimentacaoStatus: async (
    context,
    { unidadeId, dataInicial, dataFinal }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/ferramentas/status/export`, {
      params: {
        unidadeId,
        dataInicial,
        dataFinal,
      },
    });

    return response;
  },

  // Regas Unidade

  getRegrasUnidade: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/vendors/${unidadeId}/regras-de-troca-por-unidade/export`
    );

    return response;
  },

  //MovimentacaoManual

  getMovimentacaoManual: async (
    context,
    { dataInicial, dataFinal, vendorId }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/vendors/reports/movimentacao-manual-estoque/export`,
      {
        params: {
          data_inicial: dataInicial,
          data_final: dataFinal,
          vendor_id: vendorId || undefined,
        },
      }
    );

    return response;
  },

  // Devolução de Materiais
  getDevolucaoMateriais: async (
    context,
    { vendorId, data_final, data_inicial }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`devolucao/export`, {
      params: {
        vendorId,
        data_final,
        data_inicial,
      },
    });

    return response;
  },

  // Estoque Consolidado
  getEstoqueConsolidado: async (context, { vendor_id, comSaldo }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`products/estoque-consolidado/export`, {
      params: {
        vendor_id,
        com_saldo: comSaldo,
      },
    });

    return response;
  },

  // Movimentação de Estoque
  getMovimentacaoEstoque: async (context, { vendor_id, data_inicial }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `vendors/reports/movimentacao-manual-estoque/export`,
      {
        params: {
          vendor_id,
          data_inicial,
        },
      }
    );

    return response;
  },

  // Relatório MRP
  getMrp: async (context, { vendor_id, background }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendors/reports/mrp/export`, {
      params: {
        vendor_id,
        background,
      },
    });

    return response;
  },

  //Transferência de Ferramentas

  getTransferenciaEstoque: async (
    context,
    { vendor_origem, vendor_destino, data_inicial, data_final, background }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `transferencia-estoque/listagem/completa/export`,
      {
        params: {
          data_inicial,
          data_final,
          vendor_origem,
          vendor_destino,
          background,
        },
      }
    );

    return response;
  },

  // Entrada NF
  getEntradaNf: async (context, { vendor_id, data_inicial, data_final }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`nf/listagem/export`, {
      params: {
        vendor_id,
        data_inicial,
        data_final,
      },
    });

    return response;
  },

  // Retirada sem Biometria
  getRetiradasSemBiometria: async (
    context,
    { vendor_id, data_final, data_inicial }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `vouchers/report/retirada-sem-biometria/export`,
      {
        params: {
          vendor_id,
          data_final,
          data_inicial,
        },
      }
    );

    return response;
  },

  // Treinamento
  getTreinamento: async (context, { unidadeId, status }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `treinamento/funcionario/relatorio-status/export`,
      {
        params: {
          unidadeId,
          status,
        },
      }
    );

    return response;
  },
  // Centro de Custo
  getCentroDeCustos: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers/listagem`, {
      params: {
        vendor_id,
        download: "flexmonster",
      },
    });

    return response;
  },
  // Categorias
  getCategorias: async (context, { vendor_id, download }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-categories/listagem`, {
      params: {
        vendor_id,
        download,
      },
    });

    return response;
  },

  // Fornecedores
  getFornecedores: async (context, { download }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`providers/listagem`, {
      params: {
        download,
      },
    });

    return response;
  },

  // Grupo Produto
  getGrupoProduto: async (context, { vendor_id, download }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-groups/listagem`, {
      params: {
        vendor_id,
        download,
      },
    });

    return response;
  },

  // Notificação
  getNotificacao: async (context, { vendor_id, data_inicial, data_final }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `alert/relatorio/notificacoes-enviadas/export`,
      {
        params: {
          vendor_id,
          data_inicial,
          data_final,
        },
      }
    );

    return response;
  },
  // Itens Não Codificados para Compra
  getItensNaoCodificados: async (
    context,
    { vendor_id, data_inicial, data_final }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `necessidade-compra/itens-fora-catalogo/export`,
      {
        params: {
          data_inicial,
          data_final,
          vendor_id,
        },
      }
    );

    return response;
  },

  // Itens Não Codificados para Compra
  getItensCodificadosCompra: async (
    context,
    { vendor_id, data_inicial, data_final }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`necessidade-compra/detalhada/export`, {
      params: {
        data_inicial,
        data_final,
        vendor_id,
      },
    });

    return response;
  },

  // GHE
  getGhe: async (context, { regra, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`functions/listagem`, {
      params: {
        vendor_id,
        regra,
        download: "flexmonster",
      },
    });

    return response;
  },

  // Autenticações
  getAutenticacoes: async (
    context,
    { data_inicial, data_final, regiao, unidade }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/autenticacao`, {
      params: {
        data_inicial,
        data_final,
        regiao,
        unidade,
        download: "flexmonster",
      },
    });

    return response;
  },

  // Custos NF e Voucher
  getCustosNfVoucher: async (
    context,
    { data_inicial, data_final, vendor_id, status }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/report/custos/export`, {
      params: {
        data_inicial,
        data_final,
        status,
        vendor_id,
      },
    });

    return response;
  },

  // Documentos
  getDocumentos: async (
    context,
    {
      unidadeId,
      nome,
      categoria,
      tipo,
      vencimento,
      dataEmissao,
      vencimentoEmDias,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/documento/relatorio`, {
      params: {
        unidadeId,
        nome,
        categoria,
        tipo,
        vencimento,
        dataEmissao,
        vencimentoEmDias,
      },
    });

    return response;
  },

  // Tipo Documento
  getTipoDocumento: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/tipo/relatorio`);

    return response;
  },

  // Categoria Documento
  getCategoriaDocumento: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/categoria/relatorio`);

    return response;
  },

  // Documento Vinculado
  getDocumentoVinculado: async (
    context,
    {
      codigoAtivo,
      descricaoAtivo,
      patrimonioAtivo,
      nomeDocumento,
      statusDocumento,
      unidadeAtivo,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/documento/relatorio`, {
      params: {
        codigoAtivo,
        descricaoAtivo,
        patrimonioAtivo,
        nomeDocumento,
        statusDocumento,
        unidadeAtivo,
      },
    });

    return response;
  },
};

export const rel = {
  namespaced: true,
  state,
  actions,
  mutations,
};
